import type React from 'react';
import { useTranslation } from 'react-i18next';
import { SupportedProductType } from '@/types/app';
import Insurance from '../Insurance';

const PRODUCT_TYPE = SupportedProductType.SICK_LEAVE_LONG_TERM_WGA_GAP_EXTENDED;
const APPLICATION_FIELD = 'selected_wga_gap_extended_quote_id' as const;

interface WgaExtendedProps {
	id: string;
	isSaving?: boolean;
	setIsSaving?: (saving: boolean) => void;
	onConfirm?: () => void;
	onBack?: () => void;
	onLoadingChange?: (isLoading: boolean) => void;
	onItemCountChange?: (itemCount: number) => void;
	showNavigation?: boolean;
	desktopVisibleCards?: number;
}

const WgaExtended = ({
	id,
	isSaving = false,
	setIsSaving = () => {},
	onConfirm = () => {},
	onBack = () => {},
	onLoadingChange = () => {},
	onItemCountChange = () => {},
	showNavigation = true,
	desktopVisibleCards
}: WgaExtendedProps): React.JSX.Element => {
	const { t } = useTranslation();

	return (
		<Insurance
			id={id}
			productType={PRODUCT_TYPE}
			applicationField={APPLICATION_FIELD}
			carouselKeyPrefix="wga-extended"
			sectionTranslationKey="productSelection.wgaExtended"
			productName={t('productPackage.products.wgaGapExtended')}
			logLabel="WGA Hiaat Uitgebreid"
			isSaving={isSaving}
			setIsSaving={setIsSaving}
			onConfirm={onConfirm}
			onBack={onBack}
			onLoadingChange={onLoadingChange}
			onItemCountChange={onItemCountChange}
			showNavigation={showNavigation}
			desktopVisibleCards={desktopVisibleCards}
		/>
	);
};

export default WgaExtended;
